export const ROLES = {
  ISPM_ADMIN: "ROLE_SAV_ISPMADMIN",
} as const;
